
import { SvgIcon, SvgIconProps } from "@mui/material";
    
export const ReportIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
   <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.3" d="m18.503 16.634 2.5 2.501M21.004 16.634l-2.501 2.501M12.5 12.067V8.999M12.5 15.678a.16.16 0 0 0-.16.162c0 .088.072.16.16.162a.162.162 0 0 0 0-.324"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.3" d="m20.55 13.519-4.73-8.122a3.847 3.847 0 0 0-6.64 0L3.477 15.18a3.544 3.544 0 0 0 3.084 5.325h8.976"/></svg>
  </SvgIcon>
);
